<div class="dynamic-scheduler" style=" width: 100%; min-height: 100vh; background: black; display: flex; justify-content: center;">
    <div class="RadAjaxPanel" id="RadAjaxPanel1Panel" style=" width: 80%; background: white; padding: 20px; box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1); min-height: 100px; max-height: 90vh; overflow-y: auto;">
        <div id="RadAjaxPanel1" style="">
            <!-- 2020.1.219.45 -->
            <div class="canvas">
                <div class="title">
                    <h3><span id="lblTitle">{{calendarSchedulerObj?.Title}}</span></h3>
                    <h6><span id="lblPCalMessage">{{calendarSchedulerObj?.PCalMessage}}</span></h6>
                    <div id="pnlMessage"><div class="alert alert-info mb-0" *ngIf="!isApptScheduled">{{calendarSchedulerObj?.messageString}}</div></div>
                    <div class="alert alert-info" *ngIf="isApptScheduled">Your appointment is currently scheduled for {{scheduleAppointmentWeekDay}}<span *ngIf="scheduleAppointmentWeekDay">,</span> {{scheduleAppointmentMonth}} {{scheduleAppointmentDate}}, {{scheduleAppointmentYear}} <span *ngIf="scheduleAppointmentTime">at {{scheduleAppointmentTime}} {{calendarSchedulerObj?.StandardName}}</span></div>
                </div>
                <div class="body" *ngIf="!isApptScheduled">
                    <div class="">
                        <div class="dynamic-scheduler-panel">
                            <div id="pnlTime" class="time_selector">
                                <div style="text-align: center"> {{scheduleAppointmentWeekDay}}<span *ngIf="scheduleAppointmentWeekDay">,</span> {{scheduleAppointmentMonth}} {{scheduleAppointmentDate}}, {{scheduleAppointmentYear}}</div>
                                <div class="cards-colunm-right">
                                    <div class="row example-wrapper">
                                        <div class="col-xs-12 col-md-6 example-col">
                                            <kendo-calendar type="classic" [(value)]="currDate" (valueChange)="onScheduleAppointmentDateChange($event)"></kendo-calendar>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="pnlTime" class="time_selector">
                                <div  *ngIf="timeSlots?.length > 0" class="time_slot_bar" style="width: 150px;  margin: auto;">
                                        <div *ngFor="let item of timeSlots"><input class="calendar-input" type="button" [value]="item?.text" (click)="onScheduleAppointmentTimeSelect($event)"></div>
                                </div>
                                <div *ngIf="timeSlots?.length == 0">
                                    <span>No time slots available.</span>
                                </div>
                            </div>
                            <div id="pnlContact" class="confirmation_box">
                                <div class="scheduled_time" *ngIf="scheduleAppointmentTime">{{scheduleAppointmentTime}}, {{scheduleAppointmentWeekDay}}<span *ngIf="scheduleAppointmentWeekDay">,</span> {{scheduleAppointmentMonth}} {{scheduleAppointmentDate}}<span *ngIf="scheduleAppointmentYear">,</span> {{scheduleAppointmentYear}}</div>
                                <form [formGroup]="scheduleAppointmentForm" (ngSubmit)="onSubmitScheduleForm()">
                                    <div class="row">
                                        <div class="form-group col-sm-12">
                                            <label class="control-label">Name<span style="color: red">&nbsp;*</span></label>
                                            <div>
                                                <input formControlName="txtName" type="text" id="txtName" class="form-control">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="form-group col-sm-12">
                                            <label class="control-label">Email<span style="color: red">&nbsp;*</span></label>
                                            <div>
                                                <input type="text" formControlName="txtEmail" id="txtEmail" class="form-control">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="form-group col-sm-12">
                                            <label class="control-label">Mobile<span style="color: red">&nbsp;*</span></label>
                                            <div>
                                                <input type="text" formControlName="txtMobile" id="txtMobile"  minlength="10" maxlength="15" (keypress)="_localService.onKeyDown($event)" (paste)="_localService.onPaste($event)" [placeholder]="placeHolder" [mask]="mobile_mask" class="form-control">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="form-group col-sm-12">
                                            <label class="control-label">Notes</label>
                                            <div>
                                                <textarea rows="2" formControlName="txtNotes" cols="20" id="txtNotes" class="form-control" data-gramm="false" wt-ignore-input="true"></textarea>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="form-group col-sm-12">
                                            <div style="text-align: center;">
                                                <input type="submit" name="btnSchedule" [disabled]="disabelSchedule()" value="Schedule" id="btnSchedule" class="aspNetDisabled btn btn-success ml-0">
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
